import axios,{API_URL} from '../utils/axios'

const API_URL_VERSION =API_URL + "/v1/";

const login = (username,password) =>{
    return axios.post(API_URL_VERSION+"login",{username,password})
}

export default login;